import styled from '@emotion/styled'
import { Box, useTheme } from '@mui/material'

import { HouseIcon } from '@f-fertighaus/applications/Next/components/fertighaus/Icon/HouseIcon'
import { t } from '@f-fertighaus/applications/Next/public/locales/de'
import { WTPayload } from '@f-fertighaus/applications/Next/types/WTPayload'
import { useHouseDetail } from '@f-fertighaus/applications/Next/utils/context/HouseDetail'
import { getUrlByDomain } from '@js/common/getUrlByDomain'
import { webtrack } from '@f-fertighaus/applications/Next/utils/webtrack'

const MAIN_PAGE_URL = '/'

const homeWtPayload: WTPayload = {
  category: 'CTA-link',
  action: 'click',
  label: 'home',
  location: 'breadcrumb',
  values: [{ value: '(ICON)', type: 'text' }]
}

const houseListWtPayload: WTPayload = {
  category: 'CTA-link',
  action: 'click',
  label: 'house-list',
  location: 'breadcrumb',
  values: [{ value: '(ICON)', type: 'text' }]
}

export const Breadcrumbs = () => {
  const { state: data, domain } = useHouseDetail()
  const getUrl = getUrlByDomain(domain)
  const theme = useTheme()
  const HOUSE_SEARCH_URL = getUrl('houseList')()

  return (
    <StyledBox>
      <BreadcrumbLinkItem
        href={MAIN_PAGE_URL}
        onClick={() => webtrack(homeWtPayload)}
        aria-label='zur Homepage'>
        <HouseIcon color={theme.palette.text.primary} />
      </BreadcrumbLinkItem>
      <BreadcrumbLinkItem
        href={HOUSE_SEARCH_URL}
        onClick={() => webtrack(houseListWtPayload)}>
        {t('houseDetailPage.breadcrumbs.house_search')}
      </BreadcrumbLinkItem>
      <BreadcrumbItem>{data.name}</BreadcrumbItem>
    </StyledBox>
  )
}

const BreadcrumbItem = styled('p')`
  padding: 0 ${({ theme }) => theme.spacing(1)};
  margin: 0;
  color: ${({ theme }) => theme.palette.primary.main};
  font-size: 14px;
  font-family: ${({ theme }) => theme.font.base}, -apple-system,
    BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell,
    'Open Sans', 'Helvetica Neue', sans-serif;
`

const BreadcrumbLinkItem = styled('a')`
  display: flex;
  align-items: center;
  padding: 0 ${({ theme }) => theme.spacing(1)};
  color: ${({ theme }) => theme.palette.text.primary};
  text-decoration: none;
  font-size: 14px;
  font-family: ${({ theme }) => theme.font.base}, -apple-system,
    BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell,
    'Open Sans', 'Helvetica Neue', sans-serif;

  &:after {
    font-family: ${({ theme }) => theme.font.base}, -apple-system,
      BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell,
      'Open Sans', 'Helvetica Neue', sans-serif;
    display: inline-block;
    content: '›';
    font-size: 16px;
    color: ${({ theme }) => theme.palette.common.black};
    padding-left: ${({ theme }) => theme.spacing(2)};
  }

  &:first-of-type {
    padding-left: 0;
  }
`

const StyledBox = styled(Box)`
  grid-area: breadcrumbs;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  max-width: ${({ theme }) => theme.breakpoints.values['lg']}px;
  background-color: ${({ theme }) => theme.palette.common.white};
  padding: ${({ theme }) => theme.spacing(0)} ${({ theme }) => theme.spacing(0)}
    ${({ theme }) => theme.spacing(1)} ${({ theme }) => theme.spacing(0)};
  ${({ theme }) => theme.breakpoints.down('md')} {
    display: none;
  }
`
